<template>
  <div id="privacy-policy">
    <NavBar :mainPage="mainPage" />
    <section id="privacy-intro-section" class="privacy-intro-section" ref="privacypolicystart">
      <Privacypolicyintro
        class="privacy-in"
        :heading="headings.first"
        :paragraph="paragraph.first"
      />
    </section>
    <section id="privacy-policies">
      <Policies />
    </section>
    <section id="foot" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
      <Footer />
    </section>
  </div>
</template>
<script>
import Privacypolicyintro from "./privacy-policy-intro";
import Policies from "./policies";
export default {
  name: "Privacypolicy",
  components: {
    Privacypolicyintro,
    Policies,
  },
  data() {
    return {
      mainPage: false,
      headings: {
        first: "Privacy Policy ",
      },
      paragraph: {
        first:
          "The ftcash Terms of Service ('Terms') are a legally binding agreement between you, and Nomisma Mobile Solutions Pvt. Ltd using the trademark ftcash ('ftcash') and apply to your use of an ftcash account ('Account') and any ftcash products and services that you access using the ftcash Account (the 'ftcash Services'). ftcash offers a payment software platform that allows users to pay money using an internet connection. All funds transfers are performed by the Financial Institution Partner based on instructions issued through the ftcash software platform.",
      },
    };
  },
  mounted() {
    
     this.$refs.privacypolicystart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
     //window.scrollTo(0, 0);
  },
  metaInfo() {
    return{
    link: [
      { rel: 'canonical', href: 'https://www.ftcash.com/privacypolicy' },
    ],
    }
  },
};
</script>
<style scoped>
body {         
  height: auto;
  line-height: 1.6;
  overflow: scroll;
}
#privacy-policy {
  overflow-y: hidden;
}
.privacy-intro-section {
  height: 100vh;
  background-image: url("../assets/img/privacy_policy_intro.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
   background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}

/* Media Queries */
/* Tablet Screen */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  section#privacy-intro-section {
    height: 55vh;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    scroll-snap-align: center;
  }
}
/* Mobile Screen */
@media (min-width: 481px) and (max-width: 767px) {
  section#privacy-intro-section {
    height: 50vh;
    display: flex !important;
    align-items: center;
    scroll-snap-align: center;
  }
}
@media (max-width: 480px) {
  section#privacy-intro-section {
    height: 59vh;
    display: flex !important;
    align-items: center;
    scroll-snap-align: center;
  }
}
</style>